export const sliceTextByConstraint = (text, constraint, end = "...") => {
    if (!text) return ""
    if (String(text).length <= constraint) return text;

    return String(text).slice(0, constraint) + end;
};